<template>
  <div class="section-visibility-checks px-3 py-2">
    <div class="check-parent">
      <div class="title d-flex justify-content-between align-items-center">
        <span v-if="isGrossing">{{ $t('grossing.sidebar.viewMySamples') }}</span>
        <span v-if="isIncidents">{{ $t('incidents.sidebar.viewMyIncidents') }}</span>
        <span v-if="isDiagnosis">{{ $t('diagnosis.sidebar.viewMyCases') }}</span>
        <div class="switch-btn p-0 d-flex align-items-center">
          <input
            id="toggleInformSideBar"
            v-model="checked"
            type="checkbox"
            :class="checked ? 'qa-checked' : 'qa-unchecked'"
            class="offscreen"
            aria-hidden="true"
            @change="$emit('view-all-toggled', !checked)"
          >
          <label
            for="toggleInformSideBar"
            class="switch mb-0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SectionVisibilityChecks',
    props: {
        viewAllEnabled: { type: Boolean, default: false },
        isGrossing: { type: Boolean },
        isIncidents: { type: Boolean },
        isDiagnosis: { type: Boolean }
    },
    data() {
        return {
            checked: !this.viewAllEnabled
        }
    },
    watch: {
        viewAllEnabled(enabled) {
            this.checked = !enabled
        }
    }
}
</script>

<style lang="scss" scoped>
    .section-visibility-checks {
        background: vt-color(sidebar-visibility-bg);
    }

    .section-visibility-checks .switch-label {
        font-size: font-size(very-small);
        color: vt-color(dark-text);
    }
    .section-visibility-checks .switch {
        position: relative;
        display: inline-block;
        width: 30px;
        height: 16px;
        background-color: rgba(0, 0, 0, 0.25);
        border-radius: 20px;
        transition: all 0.3s;
        cursor: pointer;
    }
    .section-visibility-checks .switch::after {
        content: "";
        position: absolute;
        width: 14px;
        height: 14px;
        border-radius: 14px;
        background-color: white;
        top: 1px;
        left: 1px;
        transition: all 0.3s;
    }
    .section-visibility-checks input[type="checkbox"]:checked + .switch::after {
        transform: translateX(14px);
    }
    .section-visibility-checks input[type="checkbox"]:checked + .switch {
        background-color: vt-color(primary);
    }
    .section-visibility-checks .offscreen {
        position: absolute;
        left: -9999px;
    }

    .check-parent .title span{
        font-size:font-size(very-small);
        color: vt-color(white-light);
    }

</style>
